import React from 'react';
import PropTypes from 'prop-types';
import { TmntText } from '../Common';
import ProfileWelcomeMessage from './ProfileWelcomeMessage';

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  text: PropTypes.object.isRequired,
  loyaltyTierImageSrc: PropTypes.string.isRequired,
};

/**
 * @component LoggedInMenuHeader
 * @description Header section of the logged in menu containing profile welcome message or repudiation warning
 * @param {Object} props - Component props
 * @param {Object} props.text - Text data from GraphQL queries (merged static + dynamic)
 * @param {string} props.loyaltyTierImageSrc - Loyalty tier image source URL
 */
export default function LoggedInMenuHeader({ text, loyaltyTierImageSrc }) {
  const hasRepudiationWarning = (
    text?.repudiationWarning?.value
    && text.repudiationWarning.value.length > 0
  );

  const repudiationMessage = hasRepudiationWarning
    ? <TmntText tmnt={text?.repudiationWarning} />
    : null;

  if (hasRepudiationWarning) return repudiationMessage;

  return (
    <ProfileWelcomeMessage
      tierImageSrc={loyaltyTierImageSrc}
      tierImageAltText={text?.loyaltyTierImageAltText?.value}
    >
      <div className="h1">
        <TmntText tmnt={text?.welcomeMessageText} />
      </div>
    </ProfileWelcomeMessage>
  );
}

LoggedInMenuHeader.propTypes = propTypes;
